import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-area',
  templateUrl: './main-area.component.html',
  styleUrls: ['./main-area.component.scss']
})
export class MainAreaComponent implements OnInit {
  
  contentItems: any = [];
  contentHeader: string = '';
  contentRows: any = [];

  constructor(private contentService: ContentService, private router: Router) {
   }

  ngOnInit(): void {
    let currentUrl = this.router.url.replace('/', '');
    if(currentUrl === '') currentUrl = this.contentService.getHomePageUrl();
    const pageData = this.contentService.getPageContentByUrl(currentUrl);
    this.contentHeader = pageData.name.header;
    this.contentRows = pageData.rows;
  }

}
